var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "chi-sigpad-wrapper",
      style: {
        height: _vm.height + "px",
        width: _vm.width + "px"
      }
    },
    [
      _c("div", {
        staticClass: "chi-sigpad",
        style: { width: Math.max(0, _vm.width - 32) + "px" },
        attrs: { id: "sigpad" },
        on: {
          mousedown: _vm.mousedown,
          mousemove: _vm.mousemove,
          mouseup: _vm.mouseup,
          touchstart: _vm.mousedown,
          touchmove: _vm.mousemove,
          touchend: _vm.mouseup
        }
      }),
      _c(
        "div",
        { staticClass: "chi-sigpad-buttons" },
        [
          _c("kendo-button", {
            staticClass: "chi-sigpad-button chi-button-success",
            attrs: {
              "sprite-css-class": "chi-icon-ok",
              role: "button",
              title: "Confirm and submit signature"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.ok($event)
              }
            }
          }),
          _c("kendo-button", {
            staticClass: "chi-sigpad-button chi-button-danger",
            attrs: {
              "sprite-css-class": "chi-icon-cancel",
              role: "button",
              title: "Clear signature area"
            },
            on: {
              click: function($event) {
                $event.preventDefault()
                return _vm.clear($event)
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }